import React from "react";
import ImageTag from "../../reusebale/imageTag";
import ParagraphTag from "../../reusebale/Paragraph";

const CompanyInfo = ({ selectedLandlord }) => {
  return (
    <div className="">
      <div className="bg-white rounded-xl py-4">
        <div className="px-4 ">
          <ParagraphTag
            content="Company Info"
            classes="text-darkColor font-popinsSemiBold text-base"
          />
        </div>
        <div className="flex mt-1">
          <div className="w-[30%] flex items-start">
            <ImageTag
              path={`${
                selectedLandlord?.companyInformation?.companyLogo?.url ||
                "/assets/daashboard/company-info-Round.png"
              }`}
              classes="w-[230px] rounded-full"
              altText="logo"
            />
          </div>
          <div className="w-[70%] px-2 py-2">
            <div className="">
              <ParagraphTag
                content="Company Name"
                classes="text-darkColor font-popinsSemiBold text-[13px]"
              />
              <ParagraphTag
                content={`${selectedLandlord?.companyInformation?.companyName}`}
                classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
              />
            </div>
            <div className="">
              <ParagraphTag
                content="Complete Address"
                classes="text-darkColor font-popinsSemiBold text-[13px]"
              />
              <ParagraphTag
                content={`${selectedLandlord?.companyInformation?.completeAddress}`}
                classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
              />
            </div>
            <div className="pt-3">
              <ParagraphTag
                content="Street One"
                classes="text-darkColor font-popinsSemiBold text-[13px]"
              />
              <ParagraphTag
                content={`${selectedLandlord?.companyInformation?.street1}`}
                classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
              />
            </div>
            <div className="pt-3">
              <ParagraphTag
                content="Street Two"
                classes="text-darkColor font-popinsSemiBold text-[13px]"
              />
              <ParagraphTag
                content={`${selectedLandlord?.companyInformation?.street2}`}
                classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
              />
            </div>
            <div className="pt-2 flex">
              <div className="w-[50%]">
                <ParagraphTag
                  content="City"
                  classes="text-darkColor font-popinsSemiBold text-[13px]"
                />
                <ParagraphTag
                  content={`${selectedLandlord?.companyInformation?.city}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="w-[50%]">
                <ParagraphTag
                  content="Country"
                  classes="text-darkColor font-popinsSemiBold text-[13px]"
                />
                <ParagraphTag
                  content={`${selectedLandlord?.companyInformation?.country}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
            <div className="pt-2 flex">
              <div className="w-[50%]">
                <ParagraphTag
                  content="State"
                  classes="text-darkColor font-popinsSemiBold text-[13px]"
                />
                <ParagraphTag
                  content={`${selectedLandlord?.companyInformation?.state}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="w-[50%]">
                <ParagraphTag
                  content="Zip Code"
                  classes="text-darkColor font-popinsSemiBold text-[13px]"
                />
                <ParagraphTag
                  content={`${selectedLandlord?.companyInformation?.zipCode}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
            <div className="pt-2">
              <ParagraphTag
                content="Website"
                classes="text-darkColor font-popinsSemiBold text-[13px]"
              />
              <ParagraphTag
                content={`${selectedLandlord?.companyInformation?.companyWebsite}`}
                classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;
